angular
  .module('capability-ng-resources')
  .constant('ResourceListBuilderDTD', {
    location: {
      type: 'ngObject',
      typeDef: 'ResourceLocationBuilder'
    },
    resource_category: {
      type: 'ngObject',
      typeDef: 'ResourceCategoryBuilder'
    },
    resource_detail: {
      type: 'ngObject',
      typeDef: 'ResourceDetailsBuilder'
    },
    resource: {
      type: 'object',
      preprocessor: 'reverse-side-load-lookup',
      hint: {
        readHash: 'resource_detail',
        readProperty: 'resource',
        writeProperty: 'resourceDetails'
      },
      typeDef: {
        id: 'id',
        nk: 'string',
        name: 'string',
        description: 'string',
        favorite_id: {
          type: 'integer',
          defaultValue: false
        },
        additional_info: {
          type: 'string',
          writeToKey: 'additionalInformation'
        },
        location: {
          postprocessor: 'side-load-lookup',
          hint: {
            lookupKey: 'location'
          },
          type: 'key'
        },
        resource_category: {
          postprocessor: 'side-load-lookup',
          hint: {
            lookupKey: 'resource_category'
          },
          type: 'key'
        }
      },
      writeToKey: 'resources'
    }
  })
  .factory('ResourceListBuilder', function (Interface, ResourceListBuilderDTD) {
    return function ResourceListBuilderDTO(data) {
      var resourceCategories = {};

      // Sometimes the favorites building will pass in nothing so this is our safety check
      data = data || {};

      if (!(this instanceof ResourceListBuilderDTO)) {
        return new ResourceListBuilderDTO(data);
      }

      _.forEach(data.resource, (resource, key) => {
        resource.id = parseInt(key, 10);
      });

      if (_.isUndefined(data.resource_category)) {
        _.forEach(data.resource, (resource) => {
          resourceCategories[resource.resource_category] = {
            id: resource.resource_category
          };
        });
        data.resource_category = resourceCategories;
      }

      Interface.implement(ResourceListBuilderDTD, data, this);
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-resources/src/builders/resources_list_builder.es.js